import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#1ADF69",
  d: "M13.5 13.714h2.25zM4.973 9.143h.854c.495 0 .923.434.923.937v.869c0 .297.18.48.473.48h1.305c.292 0 .472-.183.472-.48v-.869c0-.503.428-.937.922-.937h.855c.293 0 .473-.183.473-.48v-.869c0-.503.428-.937.922-.937h.855c.293 0 .473-.183.473-.48V5.51c0-.503.428-.938.922-.938h.855c.293 0 .473-.182.473-.48v-.868c0-.503.427-.937.922-.937h.855c.293 0 .473-.183.473-.48V.48c0-.297-.18-.48-.473-.48h-1.305c-.292 0-.472.183-.472.48v.869c0 .502-.428.937-.922.937h-.855c-.293 0-.473.183-.473.48v.868c0 .503-.428.937-.922.937h-.855c-.293 0-.473.183-.473.48v.869c0 .503-.428.937-.922.937h-.855c-.293 0-.473.183-.473.48v.869c0 .503-.428.937-.922.937h-.405c-.495 0-.923-.434-.923-.937v-.869c0-.297-.18-.48-.473-.48H4.974c-.293 0-.473.183-.473.48v1.326c0 .297.18.48.473.48m7.83 4.571H2.947c-.494 0-.697-.205-.697-.708V2.994c0-.503.203-.708.697-.708h7.83c.293 0 .473-.183.473-.48V.48c0-.297-.18-.48-.473-.48H.473C.18 0 0 .183 0 .48v15.04c0 .297.18.48.473.48h14.805c.292 0 .472-.183.472-.48V9.623c0-.297-.18-.48-.473-.48h-1.304c-.293 0-.473.183-.473.48v3.383c0 .503-.203.708-.697.708"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }